'use client';
import FundsButtonContent from './FundsButtonContent';
import FundsButtonLink from './FundsButtonLink';
import useOpenCloseCashier from '../CashierWrap/useCashier/useOpenCloseCashier';
import { CashierCurrencyType } from '@/graphql/schema';

type Props = {
  currency: CashierCurrency;
  action: string;
  fullWidth?: boolean;
  type: CashierCurrencyType;
  money?: number;
  icon: string;
};

const FundsButton: FC<Props> = ({
  currency,
  action,
  fullWidth,
  type,
  children,
}) => {
  const { handleOpen } = useOpenCloseCashier({
    type,
    name: currency,
    cashierPath: action,
  });
  return (
    <FundsButtonLink
      onClick={handleOpen}
      data-gtm-event-element
      data-gtm-event-category="button_link"
      data-gtm-event-location="funds_list"
      data-gtm-event-info={action}
    >
      <FundsButtonContent
        currency={currency}
        action={action}
        fullWidth={fullWidth}
      >
        {children}
      </FundsButtonContent>
    </FundsButtonLink>
  );
};

export default FundsButton;
